// RegistroFormSection.js — El registro como una sección de la página, no como
// popup: la misma pantalla que el acceso (barra de campaña + tarjeta a un lado,
// imagen y texto al otro) con el formulario de alta dentro.
//
// El formulario NO se reescribe acá: es el mismo `AuthModal` en modo embebido,
// así que los campos, las condiciones, los catálogos y las casillas de
// aceptación salen del `registro_config` del proyecto y no hay dos formularios
// que mantener. Esta sección aporta la presentación: el armazón (PanelAcceso) y
// unos cuantos ajustes de estilo que solo afectan a esta tarjeta.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthModal from '../../AuthModal';
import PanelAcceso from './PanelAcceso';

// Claves de la sección → claves que entiende AuthModal (`auth_modal`). Así el
// admin escribe "tarjeta_fondo" y no tiene que saber cómo se llama por dentro.
const ESTILOS_TARJETA = {
  card_fondo: 'color_fondo_modal',
  card_radio: 'radio_modal',
  card_sombra: 'sombra_modal',
  card_borde: 'borde_modal',
  card_ancho: 'ancho_modal',
  color_texto_campos: 'color_texto',
  color_texto_secundario: 'color_texto_secundario',
  color_fondo_campos: 'color_fondo_input',
  color_borde_campos: 'color_borde_input',
  color_borde_campos_foco: 'color_borde_input_focus',
  ancho_borde_campos: 'ancho_borde_input',
  radio_campos: 'radio_inputs',
  card_padding: 'padding_formulario',
  boton_fondo: 'color_primario',
  boton_color: 'color_texto_boton',
  boton_radio: 'radio_botones',
  boton_borde: 'borde_boton',
  boton_ancho: 'ancho_boton',
  boton_padding: 'padding_boton',
  alineacion_boton: 'alineacion_boton',
  texto_boton: 'texto_boton_registro',
  url_destino: 'url_destino',
  color_acento: 'color_secundario',
  fuente: 'fuente',
};

const RegistroFormSection = ({ config, tl }) => {
  const c = config || {};
  const navigate = useNavigate();

  // Overrides que valen SOLO para esta pantalla: el modal de la landing y el de
  // los otros proyectos siguen con su propia configuración.
  const override = {
    // El encabezado (logo + título del modal) no va: la barra de campaña de
    // arriba ya hace de título. Se puede volver a mostrar desde el admin.
    ocultar_encabezado: c.mostrar_encabezado !== true,
    // Los rótulos van dentro del campo, como texto de ejemplo.
    etiquetas_en_placeholder: c.mostrar_etiquetas !== true,
    ocultar_tabs: true,
    // El diseño no marca los obligatorios con asterisco; se puede volver a poner.
    ocultar_asterisco: c.mostrar_asterisco !== true,
    ocultar_switch_link: c.mostrar_enlace_login !== true,
    ancho_modal: c.card_ancho || '100%',
  };
  Object.entries(ESTILOS_TARJETA).forEach(([desde, hacia]) => {
    if (c[desde]) override[hacia] = c[desde];
  });
  if (c.texto_enlace_login) override.texto_switch_a_login = c.texto_enlace_login;
  if (c.texto_enlace_login_link) override.texto_switch_a_login_link = c.texto_enlace_login_link;

  return (
    <PanelAcceso config={c} tl={tl} tarjeta={false}>
      <AuthModal
        isOpen
        embedded
        // El aire lo pone la tarjeta del propio formulario.
        embedPadding="0"
        initialTab="register"
        showLoginTab={c.mostrar_enlace_login === true}
        onClose={() => navigate(c.url_cancelar || '/')}
        configOverride={override}
      />
    </PanelAcceso>
  );
};

export default RegistroFormSection;
